const overlayMenu = document.createElement('DIV');

function mostrarOverlayMenu() {
    overlayMenu.classList.add('overlayMenu');

    const body = document.querySelector('body');
    body.appendChild(overlayMenu);
}
const menu = document.querySelector('.btn-icono');
menu.onclick = mostrarOverlayMenu;


const botonMenu = document.querySelector('#boton-menu');

function cerrarOverlay() {
    overlayMenu.remove();
    botonMenu.checked = false;
}
overlayMenu.onclick = cerrarOverlay;

// overlayMenu.onclick = function() {
//     overlayMenu.remove();
//     botonMenu.checked = false;
// }  


document.addEventListener('DOMContentLoaded', function() {
    scrollNav();

    navegacionFija();  
});

function navegacionFija() {
    const barra = document.querySelector('.navegacion-principal');

    const observer = new IntersectionObserver( function(entries) {
        if(entries[0].isIntersecting) {
            barra.classList.remove('fijo');
        } else {
            barra.classList.add('fijo');
        }
    });

    observer.observe(document.querySelector('.video'));
}


const enlaces = document.querySelectorAll('.navegacion-principal a');

function scrollNav() {
    
    enlaces.forEach( function(enlace) {
        enlace.addEventListener('click', function(e) {
            e.preventDefault();

            const seccion = document.querySelector(e.target.attributes.href.value)

            seccion.scrollIntoView({
                behavior: 'smooth',
            });

            cerrarOverlay();
        });
    });
}

const mql = window.matchMedia( '(max-width: 480px)');
    visualizarIconoInicio(mql);

function visualizarIconoInicio(mql) {
    if(mql.matches) {
        const iconoInicio = document.createElement('P');
        iconoInicio.classList.add('flecha');
        iconoInicio.innerHTML = `<a href="#inicio">&uarr;</a>`;

        const body = document.querySelector('body');
        body.appendChild(iconoInicio);

        const observador = new IntersectionObserver( function(entries) {
            if(entries[0].isIntersecting) {
                iconoInicio.classList.remove('icono-fijo');
            } else {
                iconoInicio.classList.add('icono-fijo');
            }
        });
        observador.observe(document.querySelector('.video'));  
    } 
}

const mq = window.matchMedia( '(max-width: 480px)');
    if(mq.matches) {

        const botonFlecha = document.querySelector('.flecha a');

        botonFlecha.addEventListener('click', function(e) {
            e.preventDefault();

            const inicioFlecha = document.querySelector(e.target.attributes.href.value)

            inicioFlecha.scrollIntoView({
                behavior: 'smooth',
            });
        });
    }

